import { Link } from 'react-router-dom';
import i18n from "../../i18n";

const AmountOption = (props: {
    key: string;
    merchantClass: string;
    logo: string;
    name: string;
    amount: number;
    count: number;
    onChooseAmount: () => void;

}) => {
    const currentLanguage = i18n.language.slice(0, 2);

    const active = props.count > 0;

    const onChooseAmount = () => {
        if (active) props.onChooseAmount();
    }

    const linkClass = active
        ? "amount__option"
        : `amount__option disabled-${currentLanguage}`

    return (
        <Link to="/confirm"
            className={linkClass}
            onClick={onChooseAmount}
        >
          <div className={`amount__logo background-${props.merchantClass}`}>
        <img src={props.logo} alt={`${props.name}`} />
      </div>
      <div className="amount__value">
        <h2>{props.amount},00 €</h2>
      </div>
    </Link>
  );
};

export default AmountOption;
